export default __webpack_public_path__ + "static/international-34b129b2339f6f262c4d9041c41eb2c0.mp4";